module.exports = __webpack_public_path__ + "img/dongwantushuguan.decd0544.png";